module.exports = __webpack_public_path__ + "img/instructions1.09d0d4b9.png";